// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  background: transparent;
  color: #FDFBFB;
  display: flex;
  padding: 0.375rem 0;
  flex: 0 0 63px;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  left: 1rem;
  z-index: 25;
}
header .header-left,
header .header-right {
  display: flex;
  flex-wrap: nowrap;
  padding: 0;
  width: 244px;
  justify-content: flex-end;
}
header .header-left {
  display: none;
}
header .logo {
  display: flex;
  align-items: center;
  margin: 0.4rem 0;
}
header .logo .logo__inner {
  display: block;
  height: 22px;
  width: 117px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: contain;
}
header .back-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  width: 3rem;
  color: inherit;
  font-size: 1.5rem;
}
header .header-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row;
}
header .header-actions__btn {
  padding: 0px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  font-size: 1.875rem;
  background: #667b88;
  border: 1px solid #667b88;
  color: #FDFBFB;
  box-shadow: none;
  outline: none;
  border-radius: 50%;
  transition: all 0.3s linear;
}
header .header-actions__btn:hover, header .header-actions__btn:focus {
  color: #697F8C;
  background: #f0f2f4;
}
header .header-actions__btn + .header-actions__btn {
  margin-left: 0.75rem;
}
header .header-actions__btn .btn__text {
  display: none;
}
header .header-toggle {
  background: none;
  border: none;
  color: inherit;
  padding: 0.5rem 0rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  display: none;
}
@media (max-width: 1199px) {
  header .header-left,
  header .header-right {
    padding: 0px 0.75rem;
    width: 204px;
  }
}
@media (max-width: 991px), (max-height: 699px) {
  header {
    flex: 0 0 50px;
    bottom: 5px;
  }
  header .header-left,
  header .header-right {
    padding: 0px 0.75rem;
    width: 132px;
  }
  header .header-actions__btn {
    width: 2rem;
    height: 2rem;
    font-size: 1.25rem;
    border-width: 1px;
  }
  header .header-actions__btn + .header-actions__btn {
    margin-left: 0.375rem;
  }
  header .header-actions__btn .btn__notif {
    top: 0.25rem;
    right: 0.125rem;
    width: 0.75rem;
    height: 0.75rem;
    font-size: 0.375rem;
  }
}
@media (max-width: 575px) {
  header {
    align-items: stretch;
    background: #333c50;
    position: static;
    /*.back-wrapper {
        display: flex;
    }*/
  }
  header .header-left {
    display: flex;
  }
  header .header-left,
  header .header-right {
    width: 10rem;
    align-items: flex-end;
    position: relative;
  }
  header .header-actions {
    display: none;
    flex-direction: column;
    background: #333c50;
    align-items: flex-start;
    position: absolute;
    top: 100%;
    right: 0px;
    z-index: 30;
  }
  header.menu--opened .header-actions {
    display: flex;
  }
  header .header-actions__btn {
    justify-content: flex-start;
    width: 100%;
    height: auto;
    font-size: 0.875rem;
    background: transparent;
    border: none;
    border-radius: 0%;
    padding: 0.375rem;
    color: #FDFBFB;
    border-bottom: 2px solid #FDFBFB;
  }
  header .header-actions__btn [class*=icon-] {
    font-size: 1.5rem;
  }
  header .header-actions__btn + .header-actions__btn {
    margin-left: 0rem;
  }
  header .header-actions__btn .btn__text {
    display: block;
    margin-left: 0.5rem;
    white-space: nowrap;
    font-weight: 600;
  }
  header .header-toggle {
    display: flex;
    margin-left: auto;
  }
  header .header-actions__btn .btn__notif {
    left: 1.4rem;
    right: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Header.scss","webpack://./src/styles/abstracts/_variables.scss","webpack://./src/styles/abstracts/_functions.scss"],"names":[],"mappings":"AAIA;EACI,uBAAA;EACA,cCGW;EDFX,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAHJ;AAKI;;EAEI,aAAA;EACA,iBAAA;EAEA,UAAA;EACA,YAAA;EACA,yBAAA;AAJR;AAMI;EACI,aAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AALR;AAOQ;EACI,cAAA;EACA,YAAA;EACA,YAAA;EACA,2EAAA;EACA,wBAAA;AALZ;AASI;EAEI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,cAAA;EACA,iBAAA;AATR;AAYI;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAVR;AAaI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EAGA,yBAAA;EACA,cCrEO;EDsEP,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;AAbR;AAeQ;EAKI,cAAA;EACA,mBAAA;AAjBZ;AAoBQ;EACI,oBAAA;AAlBZ;AAqBQ;EACI,aAAA;AAnBZ;AAuBI;EACI,gBAAA;EACA,YAAA;EAEA,cAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AAtBR;AE3CE;EFqEM;;IAEI,oBAAA;IACA,YAAA;EAvBV;AACF;AElBE;EF3EF;IAwHQ,cAAA;IACA,WAAA;EAvBN;EAwBM;;IAEI,oBAAA;IACA,YAAA;EAtBV;EAyBM;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;EAvBV;EAyBU;IACI,qBAAA;EAvBd;EA0BU;IACI,YAAA;IACA,eAAA;IACA,cAAA;IACA,eAAA;IACA,mBAAA;EAxBd;AACF;AE/DE;EFzDF;IAqJQ,oBAAA;IACA,mBC9HS;ID+HT,gBAAA;IAoEA;;MAAA;EA1FN;EAwBM;IACI,aAAA;EAtBV;EAyBM;;IAEI,YAAA;IACA,qBAAA;IACA,kBAAA;EAvBV;EAyBM;IACI,aAAA;IACA,sBAAA;IAEA,mBC/IK;IDgJL,uBAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;EAxBV;EA0BM;IACI,aAAA;EAxBV;EA0BM;IACI,2BAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,iBAAA;IACA,iBAAA;IAGA,cCvLG;IDwLH,gCAAA;EA1BV;EA4BU;IACI,iBAAA;EA1Bd;EA6BU;IACI,iBAAA;EA3Bd;EA8BU;IACI,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EA5Bd;EAgCM;IACI,aAAA;IACA,iBAAA;EA9BV;EAkCU;IACI,YAAA;IACA,WAAA;EAhCd;AACF","sourcesContent":["@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n\nheader {\n    background: transparent;\n    color: $color__white;\n    display: flex;\n    padding: 0.375rem 0;\n    flex: 0 0 63px;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n    position: absolute;\n    bottom: 1rem;\n    right: 1rem;\n    left: 1rem;\n    z-index: 25;\n\n    .header-left,\n    .header-right {\n        display: flex;\n        flex-wrap: nowrap;\n        // padding: 0 2rem;\n        padding: 0;\n        width: 244px;\n        justify-content: flex-end;\n    }\n    .header-left {\n        display: none;\n    }\n\n    .logo {\n        display: flex;\n        align-items: center;\n        margin: 0.4rem 0;\n\n        .logo__inner {\n            display: block;\n            height: 22px;\n            width: 117px;\n            background: functions.image('logo.svg') no-repeat center center;\n            background-size: contain;\n        }\n    }\n\n    .back-wrapper {\n        //display: none;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        width: 3rem;\n        // color: $color__primary-dark;\n        color: inherit;\n        font-size: 1.5rem;\n    }\n\n    .header-actions {\n        display: flex;\n        flex-wrap: nowrap;\n        align-items: center;\n        flex-direction: row;\n    }\n\n    .header-actions__btn {\n        padding: 0px; // required for IOS browser \n        display: flex;\n        position: relative;\n        align-items: center;\n        justify-content: center;\n        width: 3.25rem;\n        height: 3.25rem;\n        font-size: 1.875rem;\n        background: #667b88;\n        // border: 2px solid $color__primary-dark;\n        // color: $color__primary-dark;\n        border: 1px solid #667b88;\n        color: $color__white;\n        box-shadow: none;\n        outline: none;\n        border-radius: 50%;\n        transition: all 0.3s linear;\n\n        &:hover,\n        &:focus {\n            //color: $color__primary;\n            //border-color: $color__primary;\n            // background: $color__white;\n            color: #697F8C;\n            background: #f0f2f4;\n        }\n\n        & + .header-actions__btn {\n            margin-left: 0.75rem;\n        }\n\n        .btn__text {\n            display: none;\n        }\n    }\n\n    .header-toggle {\n        background: none;\n        border: none;\n        // color: $color__primary-dark;\n        color: inherit;\n        padding: 0.5rem 0rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 2rem;\n        display: none;\n    }\n\n    @include functions.responsiveTablet {\n        .header-left,\n        .header-right {\n            padding: 0px 0.75rem;\n            width: 204px;\n        }\n    }\n\n    @include functions.responsiveNewTablet {\n        flex: 0 0 50px;\n        bottom:5px;\n        .header-left,\n        .header-right {\n            padding: 0px 0.75rem;\n            width: 132px;\n        }\n\n        .header-actions__btn {\n            width: 2rem;\n            height: 2rem;\n            font-size: 1.25rem;\n            border-width: 1px;\n\n            &+.header-actions__btn {\n                margin-left: 0.375rem;\n            }\n\n            .btn__notif {\n                top: 0.25rem;\n                right: 0.125rem;\n                width: 0.75rem;\n                height: 0.75rem;\n                font-size: 0.375rem;\n            }\n        }\n    }\n\n    @include functions.responsiveSmartphone {\n        align-items: stretch;\n        background: $color__ternary;\n        position: static;\n\n        .header-left {\n            display: flex;\n        }\n\n        .header-left,\n        .header-right {\n            width: 10rem;\n            align-items: flex-end;\n            position: relative;\n        }\n        .header-actions {\n            display: none;\n            flex-direction: column;\n            // background: $color__white;\n            background: $color__ternary;\n            align-items: flex-start;\n            position: absolute;\n            top: 100%;\n            right: 0px;\n            z-index: 30;\n        }\n        &.menu--opened .header-actions {\n            display: flex;\n        }\n        .header-actions__btn {\n            justify-content: flex-start;\n            width: 100%;\n            height: auto;\n            font-size: 0.875rem;\n            background: transparent;\n            border: none;\n            border-radius: 0%;\n            padding: 0.375rem;\n            // color: $color__primary-dark;\n            // border-bottom: 2px solid $color__primary;\n            color: $color__white;\n            border-bottom: 2px solid $color__white;\n\n            [class*=\"icon-\"] {\n                font-size: 1.5rem;\n            }\n    \n            & + .header-actions__btn {\n                margin-left: 0rem;\n            }\n    \n            .btn__text {\n                display: block;\n                margin-left: 0.5rem;\n                white-space: nowrap;\n                font-weight: 600;\n            }\n        }\n\n        .header-toggle {\n            display: flex;\n            margin-left: auto;\n        }\n\n        .header-actions__btn {\n            .btn__notif {\n                left: 1.4rem;\n                right: auto;\n            }\n        }\n\n        /*.back-wrapper {\n            display: flex;\n        }*/\n    }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;","@use './variables' as *;\n\n/// Base path for assets (fonts, images...),\n/// should not include trailing slash\n/// @access public\n/// @type String\n$asset-base-path: '../assets' !default;\n\n/// Asset URL builder\n/// @access private\n/// @param {String} $type - Asset type, matching folder name\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the asset\n@function asset($type, $file, $before: '') {\n  @return url($before + $asset-base-path + '/' + $type + '/' + $file);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function image($file, $before: '') {\n  @return asset('images', $file, $before);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function picto($file, $before: '') {\n  @return asset('images/pictos', $file, $before);\n}\n\n/// Font asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the font\n/// @require {function} asset\n@function font($file, $before: '') {\n  @return asset('fonts', $file, $before);\n}\n\n\n// width < 1200px\n@mixin responsiveTablet {\n  @media (max-width: $screen-xl - 1px) {\n    @content;\n  }\n}\n\n// width < 768px OR height < 576px\n@mixin responsiveMobile {\n  @media (max-width: $screen-md - 1px), (max-height: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n// width < 576px\n@mixin responsiveSmartphone {\n  @media (max-width: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n@mixin responsiveWidth($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n\n@mixin responsiveHeight($height) {\n  @media (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveWidthOrHeight($width, $height) {\n  @media (max-width: $width), (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveNewTablet {\n  @include responsiveWidthOrHeight($screen-lg - 1px, 699px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
